module.exports = __webpack_public_path__ + "static/media/25th Avenue, San Francisco, CA1.3c9a8db8.jpg";